import { Flex, Group, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import React from "react";

interface LineItemProps {
  id?: string;
  headerText: string;
  timeText: string;
  isUnlocked?: boolean;
  children?: React.ReactNode;
}

export const LineItem = ({
  id,
  headerText,
  timeText,
  isUnlocked = false,
  children,
}: LineItemProps) => {
  const theme = useMantineTheme();
  return (
    <Stack
      id={id}
      justify="space-between"
      style={(theme) => ({
        border: "1px solid #555555",
        borderRadius: theme.radius.lg,
        backgroundColor: "#202f37",
        padding: "0.7rem",
      })}
    >
      <Flex wrap="nowrap" justify="space-between" gap={5}>
        <Text px="xs" pt="xs" fw={600} c="white" size="clamp(0.5rem, 3.4vw, 1.2rem)">
          {headerText}
        </Text>
        {!isUnlocked && (
          <Group wrap="nowrap" gap={5}>
            <Text fw={500} c="#8a8b88" size="clamp(0.5rem, 3.5vw, 1.2rem)">
              {timeText}
            </Text>
            <IconLock color="#8a8b88" size={20} />
          </Group>
        )}
      </Flex>
      {isUnlocked && children}
    </Stack>
  );
};
